import type { Scope, TransactionFilters } from "./types";

export const qk = {
  me: ["auth", "me"] as const,
  overview: (scope: Scope, month: string) => ["overview", scope, month] as const,
  accounts: () => ["accounts"] as const,
  transactions: (filters: TransactionFilters & { scope: Scope }) => ["transactions", filters] as const,
  spending: (scope: Scope, from: string, to: string) => ["spending", scope, from, to] as const,
  cashflow: (scope: Scope, months: number) => ["cashflow", scope, months] as const,
  networth: (scope: Scope, days: number) => ["networth", scope, days] as const,
  recurring: (scope: Scope) => ["recurring", scope] as const,
  runway: (scope: Scope, span: number) => ["runway", scope, span] as const,
  obStatus: ["openbudget", "status"] as const,
  syncStatus: ["sync", "status"] as const,
};

/** Everything except the session probe. Invalidated after a sync or a scope change of an account. */
export const isDataQuery = (query: { queryKey: readonly unknown[] }) => query.queryKey[0] !== "auth";
